import { doc, setDoc, deleteDoc, Timestamp } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { Cursor } from '@/types';
import { logger } from '@/lib/logger';
import { debounce } from '@/lib/debounce';

/**
 * Update cursor position for a user on a board
 * Uses debouncing to reduce Firestore writes
 */
let debouncedUpdateCursor: ((boardId: string, userId: string, username: string, x: number, y: number, color: string) => void) | null = null;

const createDebouncedUpdate = () => {
  return debounce(
    async (boardId: string, userId: string, username: string, x: number, y: number, color: string) => {
      try {
        const cursorRef = doc(db, 'boards', boardId, 'cursors', userId);
        const cursor: Cursor = {
          x,
          y,
          username,
          color,
          lastUpdated: Timestamp.now(),
        };
        await setDoc(cursorRef, cursor);
      } catch (error) {
        logger('cursor').error('Error updating cursor:', error);
      }
    },
    100 // 100ms debounce
  );
};

export const updateCursor = (
  boardId: string,
  userId: string,
  username: string,
  x: number,
  y: number,
  color: string
): void => {
  if (!debouncedUpdateCursor) {
    debouncedUpdateCursor = createDebouncedUpdate();
  }
  debouncedUpdateCursor(boardId, userId, username, x, y, color);
};

/**
 * Remove cursor when user leaves board
 */
export const removeCursor = async (
  boardId: string,
  userId: string
): Promise<void> => {
  try {
    const cursorRef = doc(db, 'boards', boardId, 'cursors', userId);
    await deleteDoc(cursorRef);
  } catch (error) {
    logger('cursor').error('Error removing cursor:', error);
  }
};


